// import Swiper core and required modules
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { collectionFilter } from '../../mixins/collectionFilter';
import reviewStars from '../../yotpo-reviews/review-stars/review-stars.vue';

export default {
  name: 'singleProdCard',
  components: {
    Swiper,
    SwiperSlide,
    ReviewStars: reviewStars,
  },
  props: ['product'],
  mixins: [collectionFilter],
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    return {
      pagination: {
        clickable: true,
      },
      onSwiper,
      onSlideChange,
      modules: [Navigation, A11y],
    };
  },
  data() {
    return {
      starSize: 'small',
    };
  },
  computed: {
    formattedStarSize() {
      let screenWidth =
        window.innerWidth > 0 ? window.innerWidth : screen.width;

      if (screenWidth < 768) {
        return (this.starSize = 'tiny');
      } else {
        return;
      }
    },
  },
  methods: {
    // format price
    formatPrice(price) {
      let currency = '$';
      //let formattedPrice = (price/100).toString(); // will return a whole number if no decimal is present.
      if (price.includes('.')) {
        // if we have decimal data, make sure it is 2 decimal places deep (for sezzle widget)
        price = parseFloat(price).toFixed(2).toString();
        price = price.replace('.00', '');
      }
      //added the turnary operator at the end for an EU legal requirement. #excludes adding this extra text to gift-cards 10/12/2020
      return `${currency}${price}`;
    },
    percentageSavings(theprice, thecompare) {
      let savings = Math.round((theprice / thecompare) * 100);
      return 100 - savings;
    },
  },
};
